import ApiService from "@/services/Api"

import {
	InboxUsageType,
	VoiceCallUsageHistoryResponse,
	VoiceCallUsageSummary
} from "@/protocols/usage"

type GetUsageHistoryParams = {
	type: InboxUsageType
	page: number
	perPage: number
	userId?: number
	createdAtFrom?: string
	createdAtTo?: string
	contactSearch?: string
}

class UsageService {
	async getUsageSummary (type: InboxUsageType): Promise<VoiceCallUsageSummary> {
		const { data } = await ApiService.get<VoiceCallUsageSummary>("/usage/summary", {
			params: {
				type
			}
		})

		return data
	}

	async getUsageHistory (params: GetUsageHistoryParams): Promise<VoiceCallUsageHistoryResponse> {
		const { data } = await ApiService.get<VoiceCallUsageHistoryResponse>("/usage/history", {
			params
		})

		return data
	}
}

export default new UsageService()
